import React, { Component } from "react";
import moment from 'moment'
import { isDayTime } from '../../../../../../../../utils'
import './weather/weather.css'
import './inter-fonts.css'
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
const weatherIcon = toAbsoluteUrl(`/weather-icons/ts_icon-`);

class WeatherPreview extends Component {
    render() {
        const { defaultThemeValue, selectedOption, weatherData, currentData } = this.props;
        const { Headline, DailyForecasts } = weatherData;
        return weatherData && Headline && DailyForecasts && DailyForecasts.length > 0 && selectedOption && selectedOption.length > 0 && selectedOption[0].label && currentData && currentData.length > 0 ? <div className="tb_weather_container tb_layout_1">

            <div className={`tb_weather ${defaultThemeValue == "0" ? `tb_light` : ``} tb_layout_portrait`} style={{ height: '100%' }}>
                <div className="tb_weather_wrap">
                    <div className="tb_weather_sec">
                        <div className="tb_weather_title">
                            {selectedOption && selectedOption.length > 0 ? <div className="tb_weather_head">
                                <div className="tb_weather_title_01">{selectedOption[0].label}</div>
                                <div className="tb_weather_date">
                                    <div className="tb_weather_day">Today</div>
                                    <div className="tb_weather_time">{moment(DailyForecasts[0].Date).format('LL')}</div>
                                </div>
                            </div> : null}
                            <div className="tb_weather_details">
                                <div className="tb_wather_ico">
                                    <img className="tb_weather_ico_ani" src={`${weatherIcon}${currentData[0].WeatherIcon}.svg`} alt="" />
                                </div>
                                <div className="tb_weather_temp">
                                    <div className="tb_weather_temp_wrap">
                                        {
                                            (weatherData.DailyForecasts[0].Temperature.Maximum.Unit == currentData[0].Temperature.Imperial.Unit) ? <><div>{currentData[0].Temperature.Imperial.Value}</div>
                                                <div className="tb_weather_deg">{currentData[0].Temperature.Imperial.Unit}</div></> : (weatherData.DailyForecasts[0].Temperature.Maximum.Unit == currentData[0].Temperature.Metric.Unit) ? <><div>{currentData[0].Temperature.Metric.Value}</div>
                                                    <div className="tb_weather_deg">{currentData[0].Temperature.Metric.Unit}</div></> : null
                                        }
                                    </div>
                                    <div className="tb_weather_feel">
                                        <div className="tb_weather_realfeel_665">RealFeel
										<div className="tb_weather_day_deg">Ⓗ</div>
                                        </div>
                                        {
                                            (weatherData.DailyForecasts[0].Temperature.Maximum.Unit == currentData[0].RealFeelTemperature.Imperial.Unit) ? <>{currentData[0].RealFeelTemperature.Imperial.Value}<div className="tb_weather_day_deg">{currentData[0].RealFeelTemperature.Imperial.Unit}</div></> : (weatherData.DailyForecasts[0].Temperature.Maximum.Unit == currentData[0].RealFeelTemperature.Metric.Unit) ? <>{currentData[0].RealFeelTemperature.Metric.Value}<div className="tb_weather_day_deg">{currentData[0].RealFeelTemperature.Metric.Unit}</div></> : null
                                        }
                                    </div>
                                </div>

                            </div>
                            <div className="tb_weather_title01">
                              {currentData[0].WeatherText}
                            </div>
                        </div>
                    </div>
                    <div className="tb_weather_sec_02">
                        <div className="tb_weather_byday">
                            {
                                DailyForecasts && DailyForecasts.length > 0 && DailyForecasts.map((item, itemKey) => <div className="tb_weather_00">
                                    <div className="tb_weather_wrapper">
                                        <div className="tb_weather_day01">
                                            <div className="tb_weather_day_title">
                                                {moment(item.Date).format('dddd')}
                                            </div>
                                            <div className="tb_weather_day_title_short">
                                                {moment(item.Date).format('ddd')}
                                            </div>
                                            <div className="tb_weather_day_ico">
                                                <img className="tb_weather_day_ani" src={isDayTime() ? itemKey == 0 ? `${weatherIcon}${currentData[0].WeatherIcon}.svg` : `${weatherIcon}${item.Day.Icon}.svg` : itemKey == 0 ? `${weatherIcon}${currentData[0].WeatherIcon}.svg` : `${weatherIcon}${item.Night.Icon}.svg`} alt="" />
                                            </div>
                                            <div className="tb_weather_day_temp">
                                                {
                                                    (itemKey == 0 && weatherData.DailyForecasts[0].Temperature.Maximum.Unit == currentData[0].Temperature.Imperial.Unit) ? <>{currentData[0].Temperature.Imperial.Value} <div className="tb_weather_day_deg"> {currentData[0].Temperature.Imperial.Unit}</div></> : (itemKey == 0 && weatherData.DailyForecasts[0].Temperature.Maximum.Unit == currentData[0].Temperature.Metric.Unit) ? <>
                                                        {currentData[0].Temperature.Metric.Value} <div className="tb_weather_day_deg"> {currentData[0].Temperature.Metric.Unit}</div></> : <>
                                                            {item.Temperature.Maximum.Value} <div className="tb_weather_day_deg"> {item.Temperature.Maximum.Unit}</div>
                                                        </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
            : null
    }
}


export default WeatherPreview;